export const container = ({ documentLeft }) => ({
    display: 'none',

    //  TODO: IE11 does not support this
    '@media(any-pointer: fine)': {
        display: 'block',
    },

    tabletLarge: {
        position: 'fixed',
        willChange: 'opacity',
        zIndex: '999',
        marginLeft: '3px',
        pointerEvents: 'none',
        opacity: documentLeft ? 0 : 1,
        transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) opacity 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) fill 0.3s',
    },
});
